/**
 * The "How did you hear about us?" answers, and how to display one.
 *
 * The chosen value is written once at signup into
 * `auth.users.raw_user_meta_data.referral_source` (see
 * server/acquisition-analytics.js, which reads it as the acquisition
 * channel). Nothing in the database constrains it, so this list is the only
 * definition of what a new signup can pick, and historic rows may hold keys
 * that are no longer offered — `god` predates this file, `twitter/x` shows up
 * in older answers. Neither is dropped: an unknown key still gets a label.
 *
 * Every surface that shows the value used to title-case the raw key inline,
 * which reads correctly for "Google" and wrong for "TikTok" and "ChatGPT".
 * `referralSourceLabel` is the one place that knows those spellings.
 */

/** Offered at signup, in the order the dropdown lists them. */
export const REFERRAL_SOURCE_OPTIONS = Object.freeze([
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'google', label: 'Google' },
  { value: 'chatgpt', label: 'ChatGPT' },
  { value: 'friend', label: 'Friend' },
  { value: 'god', label: 'God' },
]);

const LABELS = new Map(REFERRAL_SOURCE_OPTIONS.map((o) => [o.value, o.label]));

/**
 * Display text for a stored referral_source. Accepts the raw column value
 * (any casing, any padding). Unknown keys fall back to title case so a
 * historic or free-text answer still renders; empty input returns ''.
 */
export function referralSourceLabel(raw) {
  const key = String(raw ?? '').trim().toLowerCase();
  if (!key) return '';
  return LABELS.get(key) || key.charAt(0).toUpperCase() + key.slice(1);
}
